import React from 'react'
import { Button, Empty, Modal, Row } from 'antd'
import g2gImage from '../../assets/images/g2g.png'

const PreviewImage = ({ visible, onClose, imgUrl }) => {
  return (
    <Modal
      title="Preview"
      destroyOnClose={true}
      visible={visible}
      closable={false}
      footer={[
        <Button
          key="close"
          onClick={() => {
            onClose()
          }}>
          ปิด
        </Button>
      ]}>
      <Row type="flex" justify="center">
        {imgUrl ? (
          <img
            src={imgUrl}
            alt="preview"
            height={450}
            style={{ width: '100%' }}
          />
        ) : (
          <Empty
            description="ไม่มีรูปภาพ"
            image={g2gImage}
            imageStyle={{
              height: 60
            }}
          />
        )}
      </Row>
    </Modal>
  )
}

export default PreviewImage
